import React from "react";
import {Link} from "react-router-dom";

export default function PrivacyPage(){
    return(
        <div className="custor-welcome" style={{maxWidth:"900px",margin:"0 auto"}}>
            <h1>Privacy Policy</h1>
            <p>Last updated: September 2026</p>

            <h2>1. Information We Collect</h2>
            <p>When you use Custor, we may collect information such as your email address, account information, subscription information, and technical information required to operate and secure the service.</p>

            <h2>2. Software Projects and Source Code</h2>
            <p>Custor processes software projects submitted by users in order to provide code analysis and architecture analysis features. You should only submit projects that you are authorized to process.</p>

            <h2>3. How We Use Information</h2>
            <p>We use collected information to provide and improve Custor, authenticate users, process subscriptions, perform requested analyses, maintain security, and communicate with users about their accounts and the service.</p>

            <h2>4. Payments</h2>
            <p>Payments and subscription-related transactions are processed by Creem. Payment information is handled by Creem according to its applicable privacy policy and payment processing practices.</p>
            <h2>5. Data Retention</h2>
            <p>We retain account and service data for as long as reasonably necessary to provide the service, maintain security, comply with legal obligations, and resolve disputes. Specific retention periods may depend on the type of information.</p>

            <h2>6. Data Security</h2>
            <p>We take reasonable technical and organizational measures to protect information processed by Custor. However, no internet-based service can guarantee absolute security.</p>

            <h2>7. Third-Party Services</h2>
            <p>Custor may use third-party services for infrastructure, authentication, payments, email delivery, analytics, or other operational purposes. These providers may process information as necessary to provide their services.</p>

            <h2>8. Your Rights</h2>
            <p>Depending on applicable law, you may have rights regarding access to, correction of, deletion of, or restriction of processing of your personal information.</p>

            <h2>9. Changes to This Policy</h2>
            <p>We may update this Privacy Policy when necessary. The latest version will always be published on this page.</p>

            <h2>10. Contact</h2>
            <p>If you have questions about this Privacy Policy or your personal information, please contact us through the contact information provided on the Custor website.</p>

            <div style={{marginTop:"30px"}}>
                <Link to="/terms">Terms of Service</Link>{" · "}
                <Link to="/refund">Refund Policy</Link>{" · "}
                <Link to="/login">Back to Custor</Link>
            </div>
        </div>
    );
}